export const ERROR_MSGS = {
    EXISTING_ACC: "You already have a Koko account.",
    NONEXISTING_ACC: "Oops! We’re sorry, this Koko account doesn’t exist.",
    UNABLE_RETRIEVE: "Oops! We’re unable to retrieve your Daraz phone number. Try downloading the Koko app.",
    INCORRECT_PASSWORD: "Please enter a valid PIN / Password",
    UNMATCHED_PINCODE: "PIN Code doesn't match",
    INCORRECT_PINCODE: "Incorrect pincode",
    EXISTING_PAYMENT_METHOD: "Uh Oh! This card already exists in our system. Try adding a new card",
    INVALID_PAYMENT_MEHTOD: "Card declined. Oops! Please try again with a valid card or contact your bank.",
    ACC_LOCK: "User Account Locked!",
    INVALID_OTP: "Invalid Otp",
    EXPIRED_OTP: "Otp Expired",
    EXISTING_EMAIL: "Email Already Exists",
    EXISTING_NIC: "NIC Already Exists",
    INVALID_NIC: "Invalid NIC",
    SIGNUP_EMAIL_EXISTS: "An account with this email already exists.",
    SIGNUP_USERNAME_EXISTS: "This username is already taken.",
    SIGNUP_OTP_INVALID: "Invalid OTP. Please check and try again.",
    SIGNUP_OTP_EXPIRED: "This OTP has expired. Please request a new one.",
    SIGNUP_OTP_RESEND_LIMIT: "Maximum OTP resend attempts reached. Please try again later.",
    SIGNUP_MOBILE_DUPLICATE: "This mobile number is already registered. Please use a different number.",
    SIGNUP_GENERIC: "Something went wrong. Please try again.",
};

export const ONBOARDING_VALIDATION_MSGS = {
    "onboarding.update.websiteUrl.invalid": "Please enter a valid website URL.",
    "onboarding.update.googleReviewLink.invalid": "Please enter a valid Google review link.",
    "onboarding.update.socialMediaLinkUrl.invalid": "Please enter a valid URL.",
    "onboarding.update.accountNumber.invalid": "Please enter a valid account number.",
};

export const ONBOARDING_VALIDATION_FALLBACK = "Please check this field.";